import { observer } from "mobx-react-lite"
import { PopoverAlign, Popover as PopoverComponent, PopoverPosition } from "react-tiny-popover"
import styles from "./styles.module.scss"
import classNames from "classnames"
import CloseModalButton from "../../buttons/CloseModalButton"

const defaultPopoverProps = {
  clickOutsideCapture: true,
  positions: ["bottom", "top"] as ["bottom", "top"],
  padding: 12,
  reposition: true,
  align: "center" as PopoverAlign,
}

export const Popover = observer(
  ({
    isOpen,
    children,
    onClickOutside,
    wrapperClassName = "",
    positions = defaultPopoverProps.positions,
    content,
    title,
    headerRightElement,
    align = defaultPopoverProps.align,
    padding = defaultPopoverProps.padding,
    zIndex = 1000,
    testId,
  }: {
    isOpen: boolean
    children: JSX.Element
    wrapperClassName?: string
    onClickOutside: (e?: MouseEvent) => void
    positions?: PopoverPosition[] | PopoverPosition
    content: JSX.Element
    title?: string
    align?: PopoverAlign
    headerRightElement?: JSX.Element
    padding?: number
    zIndex?: number
    testId?: string
  }) => {
    return (
      <PopoverComponent
        isOpen={isOpen}
        {...defaultPopoverProps}
        positions={positions}
        align={align}
        padding={padding}
        onClickOutside={(e) => {
          // If the click is on the option, don't close the popover
          const isOptionClicked = (e?.target as { id?: string })?.id.includes("option-")
          if (isOptionClicked) return
          onClickOutside(e)
        }}
        containerStyle={{ zIndex: zIndex.toString() }}
        content={() => (
          <div className={classNames(styles.popoverWrapper, wrapperClassName)} data-testid={testId}>
            {title ? (
              <div className={styles.popoverHeader}>
                <p className={styles.popoverTitle}>{title}</p>
                <div className={styles.popoverActionButtons}>
                  {headerRightElement}
                  <CloseModalButton onClick={onClickOutside} className={styles.closeButton} />
                </div>
              </div>
            ) : null}
            {content}
          </div>
        )}
      >
        {children}
      </PopoverComponent>
    )
  },
)
